import { ManagerFiltersState as fromManagerFilters } from './state';
import {
  ManagerFiltersActionUnion,
  ManagerFiltersActionTypes
} from './actions';

export const initialManagerFilterState: fromManagerFilters = {
  filterState: {},
  defaultSelectionFilterState: {},
  unsavedDefaultSelectionFilterState: {},
  cardsFilterState: {}
};

export function managerFiltersReducer(
  state: fromManagerFilters = initialManagerFilterState,
  action: ManagerFiltersActionUnion
): fromManagerFilters {
  let newState;
  switch (action.type) {
    case ManagerFiltersActionTypes.SetCardsFilter:
      newState = {
        ...state,
        cardsFilterState: {
          ...state.cardsFilterState,
          [action.payload.name]: action.payload.value
        }
      };
      if (!action.payload.value) {
        delete newState.cardsFilterState[action.payload.name];
      }
      break;
    case ManagerFiltersActionTypes.Set:
      newState = {
        ...state,
        filterState: {
          ...state.filterState,
          [action.payload.name]: action.payload.value
        }
      };
      if (!action.payload.value) {
        delete newState.filterState[action.payload.name];
      }
      break;
    case ManagerFiltersActionTypes.SetAll:
      newState = {
        ...state,
        filterState: {
          ...action.payload
        }
      };
      break;
    case ManagerFiltersActionTypes.Reset:
      if (action.payload && action.payload.name && !action.payload.value) {
        newState = { ...state };
        delete newState.filterState[action.payload.name];
      } else {
        newState = {
          ...state,
          filterState: {}
        };
      }
      break;
    case ManagerFiltersActionTypes.SetAllUnsavedAsDefault:
      newState = {
        ...state,
        defaultSelectionFilterState: {
          ...state.unsavedDefaultSelectionFilterState
        }
      };
      break;
    case ManagerFiltersActionTypes.SetAllGridFiltersAsDefault:
      newState = {
        ...state,
        defaultSelectionFilterState: { ...state.filterState }
      };
      break;
    case ManagerFiltersActionTypes.SetAllDefaultFilters:
      newState = {
        ...state,
        defaultSelectionFilterState: { ...action.payload }
      };
      break;
    case ManagerFiltersActionTypes.ClearAllUnsavedFilters:
      newState = {
        ...state,
        unsavedDefaultSelectionFilterState: {}
      };
      break;
    case ManagerFiltersActionTypes.LoadDefaultFiltersToUnsaved:
      newState = {
        ...state,
        unsavedDefaultSelectionFilterState: {
          ...state.defaultSelectionFilterState
        }
      };
      break;
    case ManagerFiltersActionTypes.SetDefaultUnsavedFilter:
      newState = {
        ...state,
        unsavedDefaultSelectionFilterState: {
          ...state.unsavedDefaultSelectionFilterState,
          [action.payload.name]: action.payload.value
        }
      };
      if (!action.payload.value) {
        delete newState.unsavedDefaultSelectionFilterState[action.payload.name];
      }
      break;
    default:
      newState = state;
  }
  return newState;
}

export const selectManagerFilters = (state: fromManagerFilters) =>
  state.filterState;
export const selectManagerCardsFilters = (state: fromManagerFilters) =>
  state.cardsFilterState;
export const selectManagerDefaults = (state: fromManagerFilters) =>
  state.defaultSelectionFilterState;
export const selectManagerDefaultsUnsaved = (state: fromManagerFilters) =>
  state.unsavedDefaultSelectionFilterState;
